import { COMMON } from '@/translations/locales/de/common'
import { CHAT } from '@/translations/locales/en/chat'

export const de = {
  translation: {
    ...COMMON,
    ...CHAT,
  },
}
